import dataService from '../../data/data.service';
import lodash from 'lodash';
import store from '../store';

const state = {
  registrations: []
}

const getters = {
  registrations: (state) => {
    return state.registrations
  }
}

const actions = {
  get(context, params) {
    return new Promise(resolve => {
      dataService.modules.registration.get(params).then(data => {
        context.commit('get', data);
        resolve();
      });
    })
  },

  add(context, registration) {
    return new Promise((resolve, reject) => {
      dataService.modules.registration.add(registration).then((id) => {
        registration.id = id.data[0];
        context.commit('add', registration);
        resolve();
      }).catch(err => {
        reject(err);
      })
    })
  },

  update(context, registration) {
    return new Promise((resolve, reject) => {
      dataService.modules.registration.update(registration).then(() => {
          context.commit('update', registration);
          resolve();
      }).catch(err => {
        reject(err);
      })
    })
  },

  delete(context, data) {
    return new Promise(resolve => {
      dataService.modules.registration.delete(data.id).then(() => {
          context.commit('delete', data);
          resolve();
      });
    });
  },
}

const mutations = {
  get(state, data) {
    state.registrations = data;
  },

  add(state, data) {
    var sessionId = data.sessionId;
    var u = _.findIndex(store.state.session.sessions, function (u) {
      return u.sessionId === sessionId;
    });

    store.state.session.sessions[u].id = data.id;
    store.state.session.sessions[u].registeredCount = 1;
    store.state.session.sessions[u].totalRegisteredCount = data.totalRegisteredCount;
  },

  update(state, data) {
    var id = data.id;
    var u = _.findIndex(store.state.session.sessions, function (u) {
      return u.id === id;
    });
    store.state.session.sessions[u].registeredCount = data.registeredCount;
    store.state.session.sessions[u].totalRegisteredCount = data.totalRegisteredCount;
  },

  delete(state, data) {
    var id = data.id;
    var u = _.findIndex(store.state.session.sessions, function (u) {
      return u.id === id;
    });
    store.state.session.sessions[u].id = null;
    store.state.session.sessions[u].registeredCount = 0;
    store.state.session.sessions[u].totalRegisteredCount --;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}